<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl px-3 px-xl-5">
            <h1 class="fw-bold page-title fs-4 text-center pb-3" style="color:#175576">Συχνές Ερωτήσεις (FAQ)</h1>
            <div class="row clearfix">
                <div class="px-3">
                    <div class="row text-center gap-2">
                        <div class="col">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            1. Πως μπορώ να κάνω εγγραφή;
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Μπορείτε πολύ εύκολα να πατήσετε πάνω δεξιά εκεί που λέει <a class="fw-bold text-primary" href="/business-partner-request">"Καταχώρησε την επιχείρησή σου"</a>, να συμπληρώσετε τα στοιχεία της επιχείρησης και στην συνέχεια να πατήσετε "Αποστολή αίτησης".
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            2. Πως ξέρω ότι ο Δήμος αποδέχτηκε την επιχείρησή μου;
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Από την στιγμή που ο Δήμος αποδεχτεί την επιχείρησή σας θα σας έρθει email στο email που έχετε δηλώσει κατά την εγγραφή σας.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            3. Μπορώ να χρησιμοποιήσω το ίδιο email για περισσότερα από ένα καταστήματα ή παραρτήματα της επιχείρησής μου;
                                        </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Όχι, κάθε εγγραφή στην πλατφόρμα απαιτεί μοναδικό email. Εάν η επιχείρησή σας διαθέτει παραρτήματα και επιθυμείτε να τα καταχωρήσετε ξεχωριστά, θα χρειαστεί να χρησιμοποιήσετε διαφορετική διεύθυνση email για κάθε ένα.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                            4. Μπορεί να εγγραφεί οποιαδήποτε επιχείρηση στην πλατφόρμα και ανεξάρτητα από το Επιμελητήριο το οποίο ανήκει;
                                        </button>
                                    </h2>
                                    <div id="collapse4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Η εγγραφή μιας επιχείρησης στο My City Market δεν εξαρτάται από το Επιμελητήριο στο οποίο είναι εγγεγραμμένη. Απαραίτητη προϋπόθεση είναι η έδρα της επιχείρησης να βρίσκεται εντός των ορίων του Δήμου. Η επαλήθευση πραγματοποιείται μέσω του ΑΦΜ, από τον αρμόδιο χειριστή του Δήμου, ο οποίος είναι υπεύθυνος για τον έλεγχο και την έγκριση των επιχειρήσεων που προβάλλονται στην πλατφόρμα.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                            5. Γιατί κάποιες κατηγορίες στην αρχική σελίδα εμφανίζονται ανενεργές ή χωρίς χρώμα;
                                        </button>
                                    </h2>
                                    <div id="collapse5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Ορισμένες κατηγορίες εμφανίζονται ανενεργές ή χωρίς χρωματισμό επειδή δεν έχουν καταχωρηθεί ακόμη επιχειρήσεις σε αυτές. Μόλις προστεθεί έστω και μία επιχείρηση, η κατηγορία ενεργοποιείται αυτόματα.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                                            6. Ποιος μπορεί να δει την επιχείρησή μου στην πλατφόρμα;
                                        </button>
                                    </h2>
                                    <div id="collapse6" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Η προβολή είναι δημόσια, γεγονός που σημαίνει πως κάθε επισκέπτης της πλατφόρμας μπορεί να δει το προφίλ της επιχείρησής σας, τις προσφορές σας και τη θέση σας στον χάρτη.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                                            7. Μπορώ να δω όλες τις επιχειρήσεις ενός δήμου στον χάρτη; Υπάρχει δυνατότητα φιλτραρίσματος ανά κατηγορία;
                                        </button>
                                    </h2>
                                    <div id="collapse7" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Ναι, μπορείτε να δείτε συγκεντρωτικά όλες τις επιχειρήσεις ενός δήμου στον χάρτη. Επιπλέον, μπορείτε να φιλτράρετε τα αποτελέσματα ώστε να εμφανίζονται μόνο οι επιχειρήσεις μίας συγκεκριμένης κατηγορίας.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                                            8. Είναι η πλατφόρμα συμβατή με κινητά και tablet;
                                        </button>
                                    </h2>
                                    <div id="collapse8" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Ναι, η πλατφόρμα είναι πλήρως responsive, δηλαδή προσαρμόζεται αυτόματα σε όλες τις συσκευές — υπολογιστές, tablet και κινητά — προσφέροντας άνετη και εύχρηστη πλοήγηση παντού.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                                            9. Υπάρχει κόστος για τη συμμετοχή στην πλατφόρμα;
                                        </button>
                                    </h2>
                                    <div id="collapse9" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                        <div class="accordion-body text-start">
                                            Η συμμετοχή στην πλατφόρμα είναι δωρεάν για όλες τις επιχειρήσεις του δήμου, στο πλαίσιο της προσπάθειας προβολής και στήριξης της τοπικής επιχειρηματικότητας.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-toastification/dist/index.css';

export default {
    metaInfo: {
        title: 'Συχνές Ερωτήσεις (FAQ)',
        meta: [
            { name: 'description', content: 'Συχνές Ερωτήσεις (FAQ)' },
            { property: 'og:title', content: 'Συχνές Ερωτήσεις (FAQ)' },
            { property: 'og:description', content: 'Συχνές Ερωτήσεις (FAQ)' }
        ]
    }
};
</script>

<style scoped>
    .accordion{
        --bs-accordion-border-width: 0px;
    }
    .accordion-item{
        margin: 20px 0px;
        box-shadow: 0px 0px 10px 0px #dedede;
    }
    
    .accordion-body{
        box-shadow: inset 0px -10px 15px -20px;
        font-size: 16px;
    }
    .accordion-button{
        color: #175576;
        border-bottom: 0px;
    }
    .accordion-button:not(.collapsed){
        background-color: unset;
        color: #175576;
        font-weight: bold;
        border-bottom: 1px solid #175576
    }
    .accordion-button::after{
        color: #175576;
    }
    .accordion-button:focus{
        background-color: unset;
        color: #175576;
        font-weight: bold;
        border-bottom: 1px solid #175576;
        box-shadow: none !important;
    }
    .accordion-item:last-of-type .accordion-button.collapsed{
        border-bottom-right-radius: 0px;
        border-bottom-left-radius: 0px;
    }
</style>
